import { ArrowUpRight, CheckCircle } from 'lucide-react';
import React from 'react'
import { Link } from 'react-router-dom';

function BusinessRegistration() {
    const faqData = [
        {
            title: "Proprietorship",
            title1: "Pros",
            items: [
              "Easy to start",
              "Low start-up costs",
              "Low regulations",
              "Owner controls decision making",
              "All profits to owners",
              "Tax advantages",
              "Minimal working capital"
            ],
          },
          
          {
            title: "Cons",
            items: [
              "Unlimited liability",
              "Difficulty in raising capital",
              "Higher taxation rates with higher income",
              "Lack of continuity",
              "Business reliance on self",
              "May be difficult to sell"
            ],
          },
          
          {
            title: "Partnership",
            title1: "Pros",
            items: [
              "Easy to start",
              "Low start-up costs",
              "Additional sources of capital",
              "Tax advantages",
              "Limited regulation",
              "Broader management base and complementary talents"
            ],
          },
          
        
          {
            title: "Cons",
            items: [
              "Unlimited Liability",
              "Difficulty in raising capital",
              "Divided authority",
              "Suitable partners may not be available",
              "Conflicts between partners",
              "Partners can legally bind each other",
              "Lack of continuity",
              "Profits are smaller per share"
            ],
          },

          {
  title: "Corporation",
  title1: "Pros",
  items: [
    "Limited liability",
    "Possible tax advantage",
    "Ownership is transferable",
    "Continuous existence",
    "Specialized management",
    "Separate legal entity",
    "Easier to raise capital",
    "Capital gains exemptions"
  ],
},
{
    title: "Cons",
    items: [
      "More expensive to set up",
      "Closely regulated",
      "Extensive record-keeping",
      "Dividend taxation",
      "Shareholder liability",
      "Personal guarantees can undermine limited liabilities"
    ],
  }
  

        
      ];
    return (
        <div>
           {/* Hero Section */}
           <section
            className="relative text-center w-full h-[700px]"
            style={{
              backgroundImage: "url('images/formfilling.jpg')",
              backgroundSize: "cover",
              backgroundPosition: "center",
              backgroundRepeat: "no-repeat",
            }}
          >
            <div className="absolute inset-0 flex flex-col items-center justify-center bg-black bg-opacity-50 text-white p-6">
              <h1 className="text-4xl font-bold mb-4 md:text-8xl">Business  Registration </h1>
              <p className="text-lg max-w-3xl text-gray-400 md:text-3xl">
              Seamless business registration for a strong and successful financial future!
              </p>
            </div>
          </section>
    
    
          <div className="flex flex-col items-center text-center gap-12 bg-slate-900 py-12 px-6 md:px-16">
      <h2 className="text-4xl md:text-6xl font-bold text-gray-100">
      Business Tax Filing 
      </h2>
    
      <p className="text-2xl max-w-5xl text-justify text-gray-400  mx-auto">
      Start your business with confidence through our hassle-free registration services.  
    We guide you through every step, ensuring compliance with legal requirements and  
    setting up your business for success. Whether you're launching a startup or  
    formalizing an existing venture, our expert team simplifies the process,  
    helping you register your business efficiently and correctly. 
      </p>
    
      <div className="flex mt-3 justify-center">
                                         <Link to="/contactus">
        <button className="flex items-center gap-2 bg-amber-300 text-black p-3 px-6 text-lg font-semibold hover:bg-amber-600 transition">
          Schedule A Call
          <ArrowUpRight size={20} />
        </button></Link>
      </div>
    </div>
    
    <div className="max-w-3xl mx-auto p-6">
          {faqData.map((faq, index) => (
            <div key={index} className="border-b border-gray-300 pb-4 mb-4">
              <h2 className=" text-3xl md:text-4xl font-semibold text-gray-900">{faq.title}</h2>
              <h2 className=" text-3xl md:text-4xl font-semibold text-gray-900">{faq.title1}</h2>

              <ul className="mt-2 space-y-2">
                {faq.items.map((item, i) => (
                  <li key={i} className="flex text-xl mt-6 items-center text-gray-700">
                    <CheckCircle className="w-5 h-5 text-gray-500 mr-2" />
                    {item}
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
        </div>
      )
    }
    

export default BusinessRegistration